
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import { Cookies } from 'react-cookie';
import { useEffect, useState } from 'react';
import { OpenBase64Pdf, ReverseFormatDate, exportToExcel, formatDate, setFocus, setTitle, BindReportGrid } from "../Common/Common";
import Loader from '../Layout/Loader';
import { API_SERVER } from '../../EnvConfig/env_config';
import { post } from '../Common/service';
import { AlertBox, AutoCompleteBox } from '../Common/Input';
import { getCommonData } from '../Common/CommanServices';
import { useNavigate } from "react-router-dom";

const CustomerInvoiceReport = ({ open, setOpen }) => {
    const cookies = new Cookies();
    const Token = cookies.get('token')
    const navigate = useNavigate();
    const LoginUserCode = cookies.get('loginUserCode');
    const SalesPersonName = cookies.get('userName');
    const SalesPersonCode = cookies.get('salesPersonCode')
    const [isUpdate, setIsUpdate] = useState(false)
    const [SalesPersonPre, setSalesPersonPre] = useState('')
    const [CustomerData, setCustomerData] = useState([]);
    const [currentPageNo, setCurrentPageNo] = useState(1);
    const [isLoading, setIsLoading] = useState(false);
    const [SalesPerson, setSalesPerson] = useState([]);
    const [itemSummaryData, setItemSummaryData] = useState({
        totalRecord: 0,
        gridData: [{
        }]
    });
    const [ReportTypeDropDown] = useState([
        {
            ReportTypeCode: 'Summarised',
            ReportType: 'Summarised'
        },
        {
            ReportTypeCode: 'DETAIL',
            ReportType: 'DETAIL'
        },
    ]);
    const [MenuText, setMenuText] = useState("Customer Invoice Report");
    const [tableData, setTableData] = useState({
        totalRecord: 0,
        gridData: [{
        }]
    })
    const [showCancelModal, setShowCancelModal] = useState(false);
    const [cancelReason, setCancelReason] = useState('');
    const [FilterData, setFilterData] = useState({
        ReportType: ReportTypeDropDown[0].ReportTypeCode,
        PageIndex: "1",
        InvoiceNo: "",
        Customer: "",
        SalesPerson: SalesPersonCode ? SalesPersonCode + ' : ' + SalesPersonName : "",
        InvoiceDateFrom: "",
        InvoiceDateTo: "",
        IsItemSummary:false,
    });
    const HandleChange = (prop, value) => {
        setFilterData(FilterData => ({ ...FilterData, [prop]: value }));
    }

    useEffect(() => {
        setTitle('CustomerInvoiceReport', setOpen);
        setFocus('txtInvoiceNo');
        setTimeout(() => {
            setMenuText(document.title);
        }, 500)
    }, [])

    //useEffect(() => {
    //    getInvoiceData();
    //}, [FilterData.PageIndex, isUpdate]);


    const getInvoiceData = (Type = 'S', PI = FilterData?.PageIndex || "1") => {
        const loginCodeString = String(LoginUserCode);
        const data = {
            ...FilterData, Type: Type, Token, LoginUserCode: loginCodeString, PageIndex: `${PI}`
        }
        setIsLoading(true)
        post(`${API_SERVER}/api/Report/ShowExCustomerInvoiceReport`, { ...data }, (res) => {
            if (res.Status === 'SUCCESS') {
                if (Type === 'S') {
                    setTableData({
                        ...res
                    });
                }
                else {
                    if (Array.isArray(res.Data)) {
                        exportToExcel(res.Data, 'CustomerInvoiceReport');
                       
                    }
                }
            }
            else if (res.Status === "EXPIRED") {
                navigate('/Login')
            }
            else if (res.Message !== "") {
                AlertBox(res.Status, res.Message, res.Focus);
                setTableData({

                });
            }
            setIsLoading(false)
        });
    }

    const handleClearData = () => {
        setFilterData(
            {
                ReportType: ReportTypeDropDown[0].ReportTypeCode,
                PageIndex: "1",
                InvoiceNo: "",
                Customer: "",
                SalesPerson: SalesPersonCode ? SalesPersonCode + ' : ' + SalesPersonName : "",
                InvoiceDateFrom: "",
                InvoiceDateTo: "",
                IsItemSummary:false,
            }
        );

        setTableData({});
        setFocus('txtInvoiceNo');
        setIsUpdate(!isUpdate)
    }
   
    const getItemSummaryData = (Type = 'S', PI = FilterData?.PageIndex || "1") => {
        const loginCodeString = String(LoginUserCode);
        const data = {
            ...FilterData, Type: Type, Token, LoginUserCode: loginCodeString, PageIndex: `${PI}`
        }

        setIsLoading(true);

        post(`${API_SERVER}/api/Report/ShowItemSummaryReport`, data, (res) => {

            if (res.Status === "SUCCESS") {
                if (Type === 'S') {
                    setItemSummaryData({
                        ...res
                    });
                }
                else {
                    if (Array.isArray(res.Data)) {
                        exportToExcel(res.Data, 'ItemSummaryReport');

                    }
                }
            }
            else if (res.Status === "EXPIRED") {

                navigate('/Login');
            }
            else if (res.Message !== "") {
                AlertBox(res.Status, res.Message, res.Focus);
                setItemSummaryData({

                });
            }

            setIsLoading(false);
        });
    };
   
   
    const searchHandle = async () => {
        setFilterData({
            ...FilterData,
            PageIndex: "1",
        })
        if (FilterData.IsItemSummary) {
            setTableData({})
            getItemSummaryData()
        } else {
            setItemSummaryData({})
            getInvoiceData();
        }
       
    }

    const handleDownloadExcel = async () => {
        if (FilterData.IsItemSummary) {
            getItemSummaryData('E')
        }
        else {
            getInvoiceData('E');
        }
    }
    const handleChange1 = (event, value) => {
        getInvoiceData("S", value);
    };
    const handleChange2 = (event, value) => {
        getItemSummaryData("S", value);
    };
    const handlePrintData = (ID) => {
        setIsLoading(true);
        const loginCodeString = String(LoginUserCode);
        const invoiceNo = ID.InvoiceNo;

        const data = {
            InvoiceNo: invoiceNo,
            Source: "Report",
            Token,
            LoginUserCode: loginCodeString
        };
        post(`${API_SERVER}/api/Print/CustomerInvoicePrint`, { ...data }, (res) => {
            if (res.message === 'EXPIRED') {
                navigate('/Login')
            }
            else if (res.status === 'SUCCESS') {
                OpenBase64Pdf(res.documentPdfBase64, 'CustomerInvoicePrint_' + ID, '_blank');
            }
            if (res.status === 'ERROR') {
                AlertBox(res.status, res.message, res.focus);
            }
            setIsLoading(false);
        });
    }

    const getCustomer = () => {
        setCustomerData([])
        let temp = {
            Type: "GetCustomer",
            Prefix: "",
            ContextKey: SalesPersonPre.split(':')[0].trim(),
            ContextKey2: ""
        }
        const loginCodeString = String(LoginUserCode);
        const data = {
            Token: Token, LoginUserCode: loginCodeString
        }

        getCommonData({ ...data, ...temp }, (res) => {
            if (res && res.status === "SUCCESS") {
                let CustomerDatalist = res.autoCompleteData || [];
                setCustomerData(CustomerDatalist);
            } else {
                setCustomerData([]);
            }
        });
    }
    let CustomerArr = []
    for (let i = 0; i < CustomerData.length; i++) {
        let mydata = CustomerData[i]?.values
        CustomerArr.push(mydata)
    };

    const getSalesPerson = () => {
        setSalesPerson([]);
        let temp = {
            Type: "GetSalesPerson",
            Prefix: "",
            ContextKey: "",
            ContextKey2: ""
        };
        const loginCodeString = String(LoginUserCode);
        const data = {
            Token,
            LoginUserCode: loginCodeString
        };

        getCommonData({ ...data, ...temp }, (res) => {
            if (res && res.status === "SUCCESS") {
                let salesPersonData = res.autoCompleteData || [];
                setSalesPerson(salesPersonData);
            } else {
                setSalesPerson([]);
            }
        });
    };
    let SalesPersonArr = []
    for (let i = 0; i < SalesPerson.length; i++) {
        let mydata = SalesPerson[i]?.values
        SalesPersonArr.push(mydata)
    };

    const isAnyChecked = tableData?.Data?.some(item => item.checkStatus);

    const handleConfirmReverse = () => {
        const selectedInvoices = tableData?.Data
            ?.filter(item => item.checkStatus)
            ?.map(item => item.InvoiceNo);
        const invoiceNos = selectedInvoices.join(',');
        setIsLoading(true);
        const loginCodeString = String(LoginUserCode);

        const data = {
            InvoiceNo: invoiceNos,
            Token,
            LoginUserCode: loginCodeString,
            CancelReason: cancelReason,
        };

        post(`${API_SERVER}/api/Operation/UpdateInvoiceReversal`, { ...data }, (res) => {
            if (res.message === 'EXPIRED') {
                navigate('/Login')
            }
            else if (res.status === 'SUCCESS') {
                setShowCancelModal(false)
                AlertBox("SUCCESS", res.message);
                getInvoiceData(); // refresh grid
               
            }
            if (res.status === 'ERROR') {
                AlertBox(res.status, res.message, res.focus);
            }
            setIsLoading(false);
        });
    };

    const handleReverseData = () => {
        setShowCancelModal(true);
    };

    const handleCheck = (checked, item, index) => {
        setTableData(prev => {
            const newData = prev.Data.map((row, i) =>
                i === index ? { ...row, checkStatus: checked } : row
            );
            return { ...prev, Data: newData };
        });
    };

    const handleAllchange = (e) => {
        const { checked } = e.target;
        setTableData(prev => {
            const newData = prev.Data.map(row => ({ ...row, checkStatus: checked }));
            return { ...prev, Data: newData };
        });
    };

    useEffect(() => {
        if (FilterData.InvoiceDateFrom) {
            const fromDateObj = new Date(FilterData.InvoiceDateFrom);
            const toDateObj = new Date(FilterData.InvoiceDateTo);

            if (
                !FilterData.InvoiceDateTo ||
                toDateObj <= fromDateObj
            ) {
                const nextDay = new Date(fromDateObj);
                nextDay.setDate(fromDateObj.getDate() + 1);

                const formattedNextDay = formatDate(nextDay);

                setFilterData(prev => ({
                    ...prev,
                    InvoiceDateTo: formattedNextDay
                }));
            }
        }
    }, [FilterData.InvoiceDateFrom]);
   

    return (
        <main id="main" className="main" style={open ? {} : { marginLeft: "0" }}>
            <section className="section dashboard">
                <div className="row">
                    <div className="col-lg-12">
                        <div className="content-box">
                            <div className="heading-box">
                                <div className="heading">
                                    <h6 className="m-0 font-weight-bold text-primary">{MenuText}</h6>
                                </div>
                            </div>
                            <div className="form-box service-content-area">
                                <div className="row align-items-end">
                                    <div className="col-lg-3 col-md-4 col-sm-6">
                                        <div className="fields">
                                            <label className="form-label">Invoice No.</label>
                                            <input
                                                maxLength="50"
                                                id='txtInvoiceNo'
                                                type="text"
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') { setFocus("txtCustomer") };
                                                }}
                                                className="form-control"
                                                placeholder='Enter Invoice No'
                                                value={FilterData.InvoiceNo}
                                                onChange={(e) => {
                                                    setFilterData({ ...FilterData, InvoiceNo: e.target.value.toUpperCase() })
                                                }}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-lg-3 col-md-4 col-sm-6">
                                        <div className="fields">

                                            <AutoCompleteBox
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') { setFocus("txtSalesPerson") };
                                                }}
                                                label='Customer '
                                                placeholder="Customer "
                                                maxLength='50'
                                                options={CustomerArr}
                                                id='txtCustomer'
                                                required={false}
                                                ignore_common={true}
                                                onFocus={() => getCustomer()}
                                                inputValue={FilterData.Customer ? FilterData.Customer : ''}
                                                onInputChange={(event, newInputValue) => {
                                                    HandleChange('Customer', newInputValue)
                                                }}
                                            />
                                        </div>
                                    </div>

                                    <div className="col-lg-3 col-md-4 col-sm-6">
                                        <div className="fields">
                                            <AutoCompleteBox
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') { setFocus("txtInvoiceDateFrom") };
                                                }}
                                                disabled={SalesPersonCode ? true : false}
                                                label='Sales Person'
                                                placeholder="Sales Person"
                                                maxLength='50'
                                                options={SalesPersonArr}
                                                id='txtSalesPerson'
                                                required={false}
                                                ignore_common={true}
                                                onFocus={() => getSalesPerson()}
                                                inputValue={FilterData.SalesPerson ? FilterData.SalesPerson : ''}
                                                onInputChange={(event, newInputValue) => {
                                                    HandleChange('SalesPerson', newInputValue)
                                                    setSalesPersonPre(newInputValue)
                                                }}
                                            />
                                        </div>
                                    </div>

                                    <div className="col-lg-3 col-md-4 col-sm-6">
                                        <div className="fields">
                                            <label className="form-label">Invoice Date</label>
                                            <div className="row">
                                                <div className="col-6">
                                                    <DatePicker selected={ReverseFormatDate(FilterData.InvoiceDateFrom) || null}
                                                        id='txtInvoiceDateFrom'
                                                        className="form-control"
                                                        placeholderText='From Date'
                                                        dateFormat={'dd-MMM-yyyy'}
                                                        autoComplete='off'
                                                        onChange={(date) => {
                                                            setFilterData({ ...FilterData, InvoiceDateFrom: formatDate(date) })
                                                        }}
                                                        onKeyDown={(e) => {
                                                            if (e.key === 'Enter') {
                                                                setFocus('txtInvoiceDateTo')
                                                            };
                                                        }}
                                                        maxDate={new Date()}
                                                    /></div>
                                                <div className="col-6">
                                                    <DatePicker selected={ReverseFormatDate(FilterData.InvoiceDateTo) || null}
                                                        id='txtInvoiceDateTo'
                                                        className="form-control"
                                                        placeholderText='To Date'
                                                        dateFormat={'dd-MMM-yyyy'}
                                                        autoComplete='off'
                                                        onChange={(date) => {
                                                            setFilterData({ ...FilterData, InvoiceDateTo: formatDate(date) })
                                                        }}
                                                        onKeyDown={(e) => {
                                                            if (e.key === 'Enter') {
                                                                setFocus('txtReportType')
                                                            };
                                                        }}
                                                        minDate={new Date(FilterData.InvoiceDateFrom) || null}
                                                    /></div>
                                            </div>


                                        </div>
                                    </div>
                                    <div className="col-lg-3 col-md-4 col-sm-6">
                                        <div className="fields">
                                            <label className="form-label">Report Type</label>
                                            <select
                                                id='txtReportType'
                                                className="form-control"
                                                value={FilterData.ReportType}
                                                onChange={(e) => {
                                                    setFilterData({ ...FilterData, ReportType: e.target.value })
                                                }}
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') {
                                                        setFocus('btnSearch');
                                                    };
                                                }}>
                                                {
                                                    ReportTypeDropDown?.map((item, index) => {
                                                        return (
                                                            <option key={index} value={item.ReportTypeCode}>{item.ReportType}</option>
                                                        )
                                                    })
                                                }
                                            </select>
                                        </div>
                                    </div>
                                    <div className="col-lg-3 col-md-4 col-sm-6">

                                        <div className="form-check form-switch">
                                            <label
                                                className="form-check-label"
                                                htmlFor="activeCheckbox"
                                            >
                                               Item Summary
                                            </label>
                                            <input
                                                className="form-check-input"
                                                type="checkbox"
                                                id="chkActive"
                                                name='Active'
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') {
                                                        setFocus('btnSave')
                                                    };
                                                }}
                                                checked={FilterData.IsItemSummary}
                                                onChange={(e) => {
                                                    setFilterData({
                                                        ...FilterData, IsItemSummary: e.target.checked
                                                    })
                                                }}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-lg-12 mt-1">
                                        <div className="lms-new-button text-center">
                                            <button className="button save-btn" id='btnSearch' onClick={searchHandle}>
                                                <i className="bi bi-search" /> Search
                                            </button>
                                            <button className="button export-btn" onClick={handleDownloadExcel}>
                                                <i className="bi bi-download" /> Export
                                            </button>
                                            <button className="button reset-btn" onClick={handleClearData} >
                                                <i className="bi bi-arrow-clockwise" /> Reset
                                            </button>
                                            {isAnyChecked && (
                                                <button className="button cancel-btn" onClick={handleReverseData}>
                                                    <i className="bi bi-x-circle" /> Cancel Invoice/Reverse
                                                </button>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {tableData?.Data && tableData?.Data?.length >0 && <BindReportGrid tableData={tableData} setFilterData={setFilterData} filterData={FilterData} handlePrintButton={handlePrintData} currentPageNo={currentPageNo}
                handleChange1={handleChange1} PrintColumnName='PrintInvoiceNo' handleClearData={handleClearData} handleCheckboxChange={handleCheck} handleAllchange={handleAllchange} />}
            {itemSummaryData?.Data && itemSummaryData?.Data?.length > 0 && <BindReportGrid tableData={itemSummaryData} setFilterData={setFilterData} filterData={FilterData} handlePrintButton={handlePrintData} currentPageNo={currentPageNo}
                handleChange1={handleChange2} handleClearData={handleClearData} handleCheckboxChange={handleCheck} handleAllchange={handleAllchange} />
 }
            {isLoading ? <Loader text='Please wait' size='100px' img_path='./assets/img/giphy.gif' /> : <></>}

            {showCancelModal && (
                <div style={{
                    position: 'fixed', top: 0, left: 0, width: '100%', height: '100%',
                    backgroundColor: 'rgba(15, 23, 42, 0.6)',
                    backdropFilter: 'blur(4px)',
                    zIndex: 9999,
                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                    animation: 'fadeIn 0.2s ease'
                }}>
                    
                    <div style={{
                        background: '#ffffff',
                        borderRadius: '16px',
                        width: '440px',
                        boxShadow: '0 25px 60px rgba(0,0,0,0.18), 0 0 0 1px rgba(0,0,0,0.05)',
                        animation: 'slideUp 0.25s ease',
                        overflow: 'hidden'
                    }}>
                        {/* Header */}
                        <div style={{
                            background: '#000000',
                            padding: '12px 18px',
                            display: 'flex', alignItems: 'center', justifyContent: 'space-between'
                        }}>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                <div style={{
                                    width: '36px', height: '36px', borderRadius: '10px',
                                    background: 'rgba(255,255,255,0.2)',
                                    display: 'flex', alignItems: 'center', justifyContent: 'center'
                                }}>
                                    <i className="bi bi-slash-circle" style={{ color: '#fff', fontSize: '16px' }} />
                                </div>
                                <div>
                                    <h6 style={{ margin: 0, color: '#fff', fontWeight: 700, fontSize: '15px', letterSpacing: '0.2px' }}>
                                        Cancel Invoice
                                    </h6>
                                    <p style={{ margin: 0, color: 'rgba(255,255,255,0.7)', fontSize: '11px', marginTop: '1px' }}>
                                        This action cannot be undone
                                    </p>
                                </div>
                            </div>
                            <button
                                onClick={() => { setShowCancelModal(false); setCancelReason(''); }}
                                style={{
                                    background: 'rgba(255,255,255,0.15)', border: 'none',
                                    borderRadius: '8px', width: '30px', height: '30px',
                                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                                    cursor: 'pointer', color: '#fff', transition: 'background 0.2s'
                                }}
                            >
                                <i className="bi bi-x-lg" style={{ fontSize: '13px' }} />
                            </button>
                        </div>

                        {/* Body */}
                        <div style={{ padding: '24px' }}>
                            <label style={{
                                display: 'block', fontSize: '18px', fontWeight: 600,
                                color: '#374151', marginBottom: '8px', letterSpacing: '0.1px'
                            }}>
                                Cancel Reason
                                <span style={{ color: '#ef4444', marginLeft: '3px' }}>*</span>
                            </label>
                            <textarea
                                autoFocus
                                className="cancel-modal-textarea"
                                rows={2}
                                maxLength={500}
                                placeholder="Describe the reason for cancellation..."
                                value={cancelReason}
                                onChange={(e) => setCancelReason(e.target.value)}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter' && !e.shiftKey) {
                                        e.preventDefault();
                                        handleConfirmReverse();
                                    }
                                }}
                                style={{
                                    width: '100%', resize: 'none', borderRadius: '10px',
                                    border: '1.5px solid #e2e8f0', padding: '12px 14px',
                                    fontSize: '13.5px', color: '#1e293b', lineHeight: '1.6',
                                    transition: 'border-color 0.2s, box-shadow 0.2s',
                                    fontFamily: 'inherit', boxSizing: 'border-box'
                                }}
                            />
                            <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '4px' }}>
                                <span style={{ fontSize: '11px', color: '#94a3b8' }}>
                                    {cancelReason.length}/500
                                </span>
                            </div>
                        </div>

                        {/* Footer */}
                        <div style={{
                            padding: '14px 24px 20px',
                            display: 'flex', gap: '10px', justifyContent: 'flex-end',
                            borderTop: '1px solid #f1f5f9'
                        }}>
                            <button
                                className="modal-close-btn"
                                onClick={() => { setShowCancelModal(false); setCancelReason(''); }}
                                style={{
                                    padding: '9px 20px', borderRadius: '9px',
                                    border: '1.5px solid #e2e8f0', background: '#fff',
                                    color: '#64748b', fontSize: '13px', fontWeight: 600,
                                    cursor: 'pointer', transition: 'all 0.2s', fontFamily: 'inherit'
                                }}
                            >
                                <i className="bi bi-x" style={{ marginRight: '5px' }} />
                                Discard
                            </button>
                            <button
                                className="modal-confirm-btn"
                                onClick={handleConfirmReverse}
                                style={{
                                    padding: '9px 22px', borderRadius: '9px',
                                    border: 'none',
                                    background: '#00008B',
                                    color: '#fff', fontSize: '13px', fontWeight: 600,
                                    cursor: 'pointer', transition: 'all 0.2s',
                                    boxShadow: '0 2px 8px rgba(79,70,229,0.3)', fontFamily: 'inherit'
                                }}
                            >
                                <i className="bi bi-check-circle" style={{ marginRight: '6px' }} />
                                Confirm Cancel
                            </button>
                        </div>
                    </div>
                </div>
            )}
        
        </main>
    )
}
export default CustomerInvoiceReport